import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { BreadcrumComponent } from '../breadcrum/breadcrum.component';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, BreadcrumComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent {
  // Breadcrumb data for Privacy Policy page
  breadcrumbData = [{ label: 'Privacy Policy', url: null, active: true }];

  activeSection: string = 'intro';

  // Mobile accordion toggle state
  expandedSections: { [key: string]: boolean } = {
    intro: true,
    background: false,
    collect: false,
    'how-collect': false,
    'how-use': false,
    'third-party': false,
    cookies: false,
    rights: false,
    transfers: false,
    security: false,
    retention: false,
    grievance: false,
  };

  @ViewChild('introSection') introSection!: ElementRef;
  @ViewChild('backgroundSection') backgroundSection!: ElementRef;
  @ViewChild('collectSection') collectSection!: ElementRef;
  @ViewChild('howCollectSection') howCollectSection!: ElementRef;
  @ViewChild('howUseSection') howUseSection!: ElementRef;
  @ViewChild('thirdPartySection') thirdPartySection!: ElementRef;
  @ViewChild('cookiesSection') cookiesSection!: ElementRef;
  @ViewChild('rightsSection') rightsSection!: ElementRef;
  @ViewChild('transfersSection') transfersSection!: ElementRef;
  @ViewChild('securitySection') securitySection!: ElementRef;
  @ViewChild('retentionSection') retentionSection!: ElementRef;
  @ViewChild('grievanceSection') grievanceSection!: ElementRef;

  scrollToSection(section: string) {
    this.activeSection = section;
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  // Toggle mobile accordion sections
  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  // Check if section is expanded
  isExpanded(section: string): boolean {
    return !!this.expandedSections[section];
  }
}
